import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import ModeToggle from './ModeToggle';
import AdvancedTasksPanel from './AdvancedTasksPanel';
import { useAppMode } from '../contexts/AppModeContext';
import { HEADER_HEIGHT } from './Header/Header';
import api from '../services/api';

export const ADMIN_SUBBAR_HEIGHT = 41;

const AdminSubBar = ({ isAgentMode, showAdvancedTasks = false }) => {
  const { mode, setAppMode } = useAppMode();
  const navigate = useNavigate();
  const [advancedOpen, setAdvancedOpen] = useState(false);

  const handleModeChange = (nextMode) => {
    setAppMode(nextMode);
    if (nextMode === 'agent') {
      navigate('/dashboard');
    }
  };

  return (
    <>
      <div
        style={{ top: HEADER_HEIGHT }}
        className={`fixed left-0 right-0 z-50 px-6 py-2.5 flex items-center justify-between border-b border-white/[0.06] backdrop-blur-[30px] ${
          isAgentMode ? 'bg-[#030609]/80' : 'bg-black/50'
        }`}
      >
        <div className="flex items-center gap-3 flex-1">
          {!isAgentMode && showAdvancedTasks && (
            <div className="hidden sm:flex items-center gap-3 flex-1 max-w-2xl">
              <button
                type="button"
                onClick={() => setAdvancedOpen(true)}
                className="text-[10px] font-bold uppercase tracking-[0.1em] text-white/40 hover:text-white transition-colors whitespace-nowrap px-3 py-2 rounded-md"
              >
                Advanced Tasks
              </button>
            </div>
          )}
        </div>

        <div className="flex items-center gap-4">
          <ModeToggle mode={mode} onChange={handleModeChange} size="sm" />
        </div>
      </div>

      {advancedOpen && <AdvancedTasksPanel onClose={() => setAdvancedOpen(false)} />}
    </>
  );
};

export const useAdminLocalBar = (isAdmin) => {
  const [showBar, setShowBar] = useState(false);

  useEffect(() => {
    if (!isAdmin) {
      setShowBar(false);
      return;
    }

    let cancelled = false;

    api
      .get('/api/config')
      .then((response) => {
        if (!cancelled) {
          setShowBar(response.data?.dbLocal === true);
        }
      })
      .catch(() => {
        if (!cancelled) {
          setShowBar(false);
        }
      });

    return () => {
      cancelled = true;
    };
  }, [isAdmin]);

  return showBar;
};

export default AdminSubBar;
